import { initialConfigsState } from "../constants/configs";
import { Types } from "../actions/configs";

export const configsReducer = (state = initialConfigsState, action) => {
  const { type, payload } = action;

  switch (type) {
    case Types.SET_CONFIGS:
      return {
        ...state,
        cancelationDisabledOrgIds: payload?.cancelationDisabledOrgIds,
        loading: false,
      };

    default:
      return state;
  }
};
